import { getContext } from "@icg360/pi-syntax-tools";
import { referenceTables } from "../reference-tables";
import { stringifyValue } from "../utils/stringify-value";
import { tryExecSyntaxForEventStatement } from "./execute-syntax";
function* executeEvent(state, eventSet, eventContext, iterableIndex) {
    const { env, terms, iterables } = state;
    const { termName, iterableName, events } = eventSet;
    const term = getTerm(state, termName, iterableName, iterableIndex);
    const context = getContext({
        env,
        meta: referenceTables[state.key].model.meta,
        terms,
        iterables,
        this: iterableName && iterableIndex !== undefined
            ? {
                index: iterableIndex,
                position: iterableIndex + 1,
                term,
                iterable: state.iterables[iterableName],
                terms: state.iterables[iterableName].instances[iterableIndex].terms,
                event: eventContext,
            }
            : {
                term,
                event: eventContext,
            },
    });
    loopSet: for (const statements of events) {
        let useNextSet = true;
        for (const statement of statements) {
            if (statement.type === "term-event-suppose" &&
                statement.condition.type === "syntax-tree") {
                const output = tryExecSyntaxForEventStatement(statement.condition.tree, context, statement, eventSet, iterableIndex);
                if (!output) {
                    continue loopSet;
                }
            }
            if (statement.type === "term-event-when" &&
                statement.condition.type === "syntax-tree") {
                const output = tryExecSyntaxForEventStatement(statement.condition.tree, context, statement, eventSet, iterableIndex);
                useNextSet = Boolean(output);
            }
            if (statement.type === "term-event-set" && useNextSet) {
                if (statement.value.type === "syntax-tree") {
                    const output = tryExecSyntaxForEventStatement(statement.value.tree, context, statement, eventSet, iterableIndex);
                    const outputValue = stringifyValue(output, term);
                    if (term.value !== outputValue) {
                        term.input = outputValue;
                        term.value = outputValue;
                        if (state.phase === "INITIAL") {
                            term.ready = outputValue;
                        }
                        yield iterableName && iterableIndex !== undefined
                            ? {
                                type: "iterable-term",
                                iterableName,
                                iterableIndex,
                                termName,
                                property: "value",
                            }
                            : { type: "term", termName, property: "value" };
                    }
                }
                if (statement.value.type === "text") {
                    if (term.value !== statement.value.value) {
                        term.input = statement.value.value;
                        term.value = statement.value.value;
                        if (state.phase === "INITIAL") {
                            term.ready = statement.value.value;
                        }
                        yield iterableName && iterableIndex !== undefined
                            ? {
                                type: "iterable-term",
                                iterableName,
                                iterableIndex,
                                termName,
                                property: "value",
                            }
                            : { type: "term", termName, property: "value" };
                    }
                }
                continue loopSet;
            }
            if (statement.type === "term-event-set" && !useNextSet) {
                // If the following statement is a set, use it
                useNextSet = true;
            }
        }
    }
}
export function* executeEvents(state, eventSets, event, origin) {
    if (!eventSets) {
        return;
    }
    for (const eventSet of eventSets) {
        // If these events didn't originate from an iterable index then we need
        // to run the expression on each index of the iterable.
        if (eventSet.iterableName &&
            eventSet.iterableName !== (origin === null || origin === void 0 ? void 0 : origin.iterableName)) {
            for (let i = 0; i < state.iterables[eventSet.iterableName].count; i += 1) {
                yield* executeEvent(state, eventSet, event, i);
            }
            continue;
        }
        yield* executeEvent(state, eventSet, event, origin === null || origin === void 0 ? void 0 : origin.iterableIndex);
    }
}
function getTerm(state, termName, iterableName, iterableIndex) {
    if (iterableName && iterableIndex !== undefined) {
        return state.iterables[iterableName].instances[iterableIndex].terms[termName];
    }
    return state.terms[termName];
}
//# sourceMappingURL=execute-events.js.map